import { useMediaQuery } from "react-responsive";
import DesignConstants from "../constants/DesignConstants";

export enum Breakpoint {
    SM = "SM",
    MD = "MD",
    LG = "LG",
    XL = "XL",
}

const useBreakpoints = () => {
    const isAboveSM = useMediaQuery({ query: `(min-width: ${DesignConstants.BREAKPOINTS.SM}px)` });
    const isAboveMD = useMediaQuery({ query: `(min-width: ${DesignConstants.BREAKPOINTS.MD}px)` });
    const isAboveLG = useMediaQuery({ query: `(min-width: ${DesignConstants.BREAKPOINTS.LG}px)` });
    const isAboveXL = useMediaQuery({ query: `(min-width: ${DesignConstants.BREAKPOINTS.XL}px)` });

    /**
     * Since we use vanilla Create React App, our Tailwind setup doesn't support
     * responsive prefixes like `md:` or `lg:`.
     *
     * Because of that, we have our own getStyleBasedOnBreakpoint helper function:
     * md:flex-row flex-col ->
     * getStyleBasedOnBreakpoint(Breakpoint.MD, "flex-row", "flex-col")
     */
    const getStyleBasedOnBreakpoint = (breakPoint: Breakpoint, breakpointStyle: string, defaultStyle?: string) => {
        let isAboveBreakpoint = false;
        switch (breakPoint) {
            case Breakpoint.SM:
                isAboveBreakpoint = isAboveSM;
                break;
            case Breakpoint.MD:
                isAboveBreakpoint = isAboveMD;
                break;
            case Breakpoint.LG:
                isAboveBreakpoint = isAboveLG;
                break;
            case Breakpoint.XL:
                isAboveBreakpoint = isAboveXL;
                break;
            default:
                break;
        }

        if (isAboveBreakpoint) {
            return breakpointStyle;
        } else {
            return defaultStyle ?? "";
        }
    };

    return { getStyleBasedOnBreakpoint, isAboveSM, isAboveMD, isAboveLG, isAboveXL };
};

export default useBreakpoints;
